import { BaseComponent } from '../../components/base-component'
import { CartAPI } from '../../api/cart-api'
import { fetchConfig } from '../../utils/fetch-config'
import { parseHTML } from '../../utils/dom'
import { debounce } from '../../utils/debounce'
import { CartItem } from './cart-item'
import { BodyElement } from 'src/scripts/components/body-element/body-element'
import { $el, $list } from 'src/scripts/utils/utils'

const BODY_ELEMENT_SELECTOR = 'body-element'

export class CartPage extends BaseComponent {
  cartAPI: CartAPI = new CartAPI()
  cartState: Node

  mountComponent(): void {
    this.setCartState()

    this.addListener(this, 'change', this.handleCartChange)
    this.addListener(this, 'change', this.handleItemChange)
  }

  handleItemChange = (event): void => {
    const item: CartItem = $el(`#CartItem-${+event.target.dataset.index}`, this)
    item?.setLoading(true)
  }

  handleCartChange = debounce((event): void => {
    this.updateItem(+event.target.dataset.index, event.target.value)
  }, 500)

  setCartState = () => {
    this.cartState = this.cloneNode(true)
  }

  resetToPrevCartState = () => {
    this.replaceWith(this.cartState)
  }

  updateItem(itemIndex: number, quantity: number): Promise<void> {
    const item: CartItem = $el(`#CartItem-${itemIndex}`)

    if (!item) {
      return
    }

    const currentQuantity = +(item.dataset.quantity || 0)

    if (currentQuantity === +quantity) {
      item.setLoading(false)
      return
    }

    if (+quantity === 0) {
      const items = $list('cart-item', this)
      this.updateEmptyStatus(items.length === 1)
      item.removeItem()
    }

    this.emit('start-update', {})

    item.setDisabled(true)

    this.cartAPI
      .change({
        ...fetchConfig(),
        body: JSON.stringify({
          line: itemIndex + 1,
          quantity,
          sections: this.dataset.sectionId,
          sections_url: window.location.pathname,
        }),
      })
      .then(state => {
        item.setDisabled(false)
        item.setLoading(false)
        this.emit('update-nodes', {
          node: parseHTML(JSON.parse(state).sections[this.dataset.sectionId]),
        })

        this.setCartState()
      })
      .catch(() => {
        this.showError()
        item.setDisabled(false)
        item.setLoading(false)
        this.emit('stop-update', {})

        this.resetToPrevCartState()
      })
  }

  async purchaseHandler(html, parsedState): Promise<void> {
    this.emit('update-nodes', {
      node: html,
    })

    const item: CartItem = $el(
      `cart-item[data-variant-id="${parsedState.id}"]`,
      this,
    )

    if (!item) {
      return
    }

    if (parsedState.quantity === 1) {
      await item.showAsNew()
    }

    item.showCheckmark()
  }

  showError(): void {
    const bodyElement: BodyElement = $el(BODY_ELEMENT_SELECTOR)

    bodyElement.showNotification(
      window.auroraThemeLocales.cartStrings.error,
      'warning',
    )
  }

  updateEmptyStatus(isEmpty: boolean): void {
    this.classList.toggle('is-empty', isEmpty)

    if (isEmpty) {
      this.emit('cartIsEmpty', {})
    }
  }
}
